var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"info-card pa-3",attrs:{"elevation":"0","rounded":"lg"}},[_c('v-row',{staticClass:"d-flex flex-row flex-nowrap align-top justify-center px-4",attrs:{"align-content":"center","justify":"start"}},[_c('p',{staticClass:"body-3 font-weight-regular my-3",domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }